import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen bg-gradient-to-br from-primary/20 to-background overflow-hidden pt-20">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-background opacity-50" />

      {/* Video Background */}
      <video 
        autoPlay 
        loop 
        muted 
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/videos/hero.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay to ensure text is readable */}
      <div className="absolute inset-0 bg-black opacity-[0.65]"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center justify-center text-center px-6">
        <motion.div
          className="space-y-8 flex flex-col items-center"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.5, duration: 1.2, ease: "easeOut" }}
        >
          <motion.h1
            className="text-7xl md:text-8xl lg:text-9xl font-black tracking-tighter leading-none text-foreground"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 3, duration: 1 }}
          >
            <motion.span
              className="block text-transparent bg-clip-text bg-gradient-to-r from-primary to-ring text-4xl md:text-5xl font-light tracking-wider mt-4"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 3.5, duration: 0.8 }}
            >
              Shaping Meaningful Collaborations
            </motion.span>
          </motion.h1>{/* Main Heading Text Color */}

          <motion.p
            className="text-xl md:text-2xl text-white max-w-3xl mx-auto leading-relaxed"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 4, duration: 0.8 }}
          >
            A premium public relations and events company crafting strategic communications 
            and unforgettable experiences across the Philippines
          </motion.p>

          <motion.button
            onClick={scrollToAbout}
            className="group relative px-12 py-4 bg-transparent text-primary hover:text-background transition-all duration-500 overflow-hidden rounded-lg"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 4.5, duration: 0.8 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.div
              className="absolute inset-0 bg-primary transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"
              style={{ clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0% 100%)' }}
            />
            <span className="relative text-lg font-semibold tracking-wider">
              START THE EXPERIENCE
            </span>
          </motion.button>{/* Button Styles */}

          <motion.button
            onClick={scrollToContact}
            className="group relative px-12 py-4 bg-transparent text-ring hover:text-background transition-all duration-500 overflow-hidden rounded-lg"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 4.7, duration: 0.8 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <motion.div
              className="absolute inset-0 bg-ring transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"
              style={{ clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0% 100%)' }}
            />
            <span className="relative text-lg font-semibold tracking-wider">
              CONTACT US
            </span>
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
